export default {
  "content": "<path d=\"M14.48 1.41c.207.2.22.534.02.748l-6.24 6.7c-.28.3-.673.466-1.08.466a1.47 1.47 0 01-1.073-.486L.14 2.184a.534.534 0 01.033-.746l.64-.594c.22-.2.56-.186.76.034L7.2 7.164 13.093.831c.2-.22.547-.227.76-.02l.627.6z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "15",
    "height": "10",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};